import React from 'react';

import { Props } from '@robinhood/design/product/components/IconButton';
import dynamic from 'next/dynamic';

// Dynamically import IconButton to prevent hydration issues
const IconButtonComponent = dynamic(
  () => import('@robinhood/design/product/components/IconButton').then((mod) => ({ default: mod.IconButton })),
  { ssr: false },
);

const IconButton = (props: Props) => {
  const [isClient, setIsClient] = React.useState(false);

  React.useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? <IconButtonComponent {...props} /> : null;
};

export default IconButton;
